module.exports = __webpack_public_path__ + "img/NewsCenterDetails7_pic4.1fa35b23.png";